const SnackBarActionTypes = {
  UPDATE_ERROR_MESSAGE: 'UPDATE_ERROR_MESSAGE',
  UPDATE_SUCCESS_MESSAGE: 'UPDATE_SUCCESS_MESSAGE',
  EMPTY_MESSAGE: 'EMPTY_MESSAGE',
};
export default SnackBarActionTypes;
